// extracted by mini-css-extract-plugin
export default {"radio":"VeloTableMobileSort_radio__4OA8x"};